import React from 'react';
import { User, MapPin, Phone, Mail, Calendar, Hash, StickyNote, Tag } from 'lucide-react';
import useEditorStore from '../store/useEditorStore';
import { updateActiveTabMeta } from '../store/tabsManager';

function Field({ icon, label, value, onChange, type = 'text', placeholder = '', testid }) {
  return (
    <div className="meta-field">
      <label>{icon}{label}</label>
      {type === 'textarea' ? (
        <textarea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={3}
          data-testid={testid}
        />
      ) : (
        <input
          type={type}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid={testid}
        />
      )}
    </div>
  );
}

export default function ProjectMetaPanel() {
  const meta = useEditorStore((s) => s.meta);
  const setMeta = useEditorStore((s) => s.setMeta);

  const update = (patch) => {
    setMeta(patch);
    updateActiveTabMeta(patch);
  };

  return (
    <div className="panel-card">
      <h3><Tag size={14} /> Informations projet</h3>
      <div className="meta-grid">
        <Field
          icon={<Tag size={11} />} label="Nom du projet"
          value={meta.name}
          onChange={(v) => update({ name: v })}
          placeholder="Ex: Enseigne Restaurant Le Gourmet"
          testid="meta-name"
        />
        <Field
          icon={<Hash size={11} />} label="Référence interne"
          value={meta.reference}
          onChange={(v) => update({ reference: v })}
          placeholder="Ex: PRO-2026-042"
          testid="meta-reference"
        />
        <Field
          icon={<User size={11} />} label="Client"
          value={meta.client}
          onChange={(v) => update({ client: v })}
          placeholder="Raison sociale ou nom du client"
          testid="meta-client"
        />
        <Field
          icon={<MapPin size={11} />} label="Adresse d'installation"
          value={meta.installAddress}
          onChange={(v) => update({ installAddress: v })}
          placeholder="N° rue, ville, code postal"
          testid="meta-address"
        />
        <Field
          icon={<Mail size={11} />} label="Email contact"
          value={meta.contactEmail}
          onChange={(v) => update({ contactEmail: v })}
          type="email"
          placeholder="contact@client.fr"
          testid="meta-email"
        />
        <Field
          icon={<Phone size={11} />} label="Téléphone contact"
          value={meta.contactPhone}
          onChange={(v) => update({ contactPhone: v })}
          type="tel"
          placeholder="+33 6 ..."
          testid="meta-phone"
        />
        <Field
          icon={<Calendar size={11} />} label="Échéance"
          value={meta.deadlineDate}
          onChange={(v) => update({ deadlineDate: v })}
          type="date"
          testid="meta-deadline"
        />
        <Field
          icon={<StickyNote size={11} />} label="Notes"
          value={meta.notes}
          onChange={(v) => update({ notes: v })}
          type="textarea"
          placeholder="Spécificités, contraintes, accessoires..."
          testid="meta-notes"
        />
      </div>
    </div>
  );
}
